// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/cfs-entry.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/cfs-entry/cfs-entry.js';

mount([g0]);
